var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field',{attrs:{"delimiter":_vm.options.breakAfter,"data-qa":_vm.options.name || _vm.id,"error-schema":_vm.errorSchema},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.value}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }